import { hasSubclassFeature } from '../index.mjs';

// Kept apart from ranger.mjs so the class rules stay independent of the subclass registry
// (the server loads this after the registry; see server/utils/rogueRules.js).
/** Hunter's Prey (Hunter 3): one option at a time, saved at `classState.ranger.huntersPrey`. */
export const HUNTERS_PREY_FEATURE_ID = 'ranger:hunter:hunters-prey';
export const COLOSSUS_SLAYER_FEATURE_ID = 'ranger:hunter:colossus-slayer';
export const HORDE_BREAKER_FEATURE_ID = 'ranger:hunter:horde-breaker';
export const HUNTERS_LORE_FEATURE_ID = 'ranger:hunter:hunters-lore';
export const HUNTERS_PREY_OPTIONS = Object.freeze([
  Object.freeze({ id: 'colossus-slayer', name: 'Colossus Slayer', summary: 'Once per turn, +1d8 weapon damage to a creature missing any Hit Points.' }),
  Object.freeze({ id: 'horde-breaker', name: 'Horde Breaker', summary: 'Once per turn, attack a second creature within 5 feet of your target with the same weapon.' }),
]);
export const hasHuntersPreyFeature = character => hasSubclassFeature(character, HUNTERS_PREY_FEATURE_ID);
export const getHuntersPrey = character => HUNTERS_PREY_OPTIONS.find(option => option.id === character?.classState?.ranger?.huntersPrey?.id) || null;
/** Every Short or Long Rest increments `restState.revision`; the choice can change once a rest follows it. */
export const restRevision = character => Math.max(0, Number(character?.restState?.revision) || 0);
export const canChangeHuntersPrey = character => {
  if (!hasHuntersPreyFeature(character)) return false;
  const saved = character?.classState?.ranger?.huntersPrey;
  return !saved?.id || restRevision(character) > (Number(saved.restRevision) || 0);
};
export const needsHuntersPrey = character => hasHuntersPreyFeature(character) && !getHuntersPrey(character);

/** Defensive Tactics (Hunter 7): one option at a time, saved at `classState.ranger.defensiveTactics`. */
export const DEFENSIVE_TACTICS_FEATURE_ID = 'ranger:hunter:defensive-tactics';
export const DEFENSIVE_TACTICS_OPTIONS = Object.freeze([
  Object.freeze({ id: 'escape-the-horde', name: 'Escape the Horde', summary: 'Opportunity Attacks have Disadvantage against you.' }),
  Object.freeze({ id: 'multiattack-defense', name: 'Multiattack Defense', summary: 'When a creature hits you with an attack roll, it has Disadvantage on all other attack rolls against you this turn.' }),
]);
export const hasDefensiveTacticsFeature = character => hasSubclassFeature(character, DEFENSIVE_TACTICS_FEATURE_ID);
export const getDefensiveTactics = character => (hasDefensiveTacticsFeature(character)
  ? DEFENSIVE_TACTICS_OPTIONS.find(option => option.id === character?.classState?.ranger?.defensiveTactics?.id) || null : null);
export const canChangeDefensiveTactics = character => {
  if (!hasDefensiveTacticsFeature(character)) return false;
  const saved = character?.classState?.ranger?.defensiveTactics;
  return !saved?.id || restRevision(character) > (Number(saved.restRevision) || 0);
};
export const needsDefensiveTactics = character => hasDefensiveTacticsFeature(character) && !getDefensiveTactics(character);
export const ESCAPE_THE_HORDE_DISADVANTAGE_SOURCE = 'Target: Escape the Horde';

export const SUPERIOR_HUNTERS_PREY_FEATURE_ID = 'ranger:hunter:superior-hunters-prey';
export const SUPERIOR_HUNTERS_PREY_RANGE_FEET = 30;
export const SUPERIOR_HUNTERS_DEFENSE_FEATURE_ID = 'ranger:hunter:superior-hunters-defense';
